import { CompanyContext } from "contexts/CompanyContext";
import React, { useContext, useState } from "react";
import { formatNumber } from "utils/formatNumber";
import TextPreview from "./components/TextPreview";
import MediaPreview from "./components/MediaPreview";
import AddAssetButton from "./components/AddAssetButton";

const YoutubeVideoPreview = (post) => {
    const [isTitleFocused, setIsTitleFocused] = useState(false);

    const {
        user_name,
        user_image,
        text,
        media,
        like_count,
        className,
        title,
        assets,
        postIndex,
        isEditable,
        onAssetDelete,
        onAssetEdit,
        onAssetNew,
        onTextEdit,
        onTitleEdit,
        isSimpleView,
    } = post;

    const network = "youtube";
    const { company, companySocials } = useContext(CompanyContext);
    const integration = companySocials?.filter(e => e.type === "youtube")?.[0];

    if (post?.preferences?.media_product_type != "FEED") return <></>;

    return (
        <div className={`youtube flex flex-col ${className}`}>
            {/* Video Section */}
            {assets?.length > 0 &&
                <MediaPreview 
                    asset={assets[0]} 
                    parentClassName="w-full aspect-video"
                    className="w-full h-full object-cover" 
                    network={network}
                    isEditable={isEditable && !isSimpleView}
                    onAssetDelete={() => onAssetDelete(postIndex, 0)}
                    onAssetEdit={(src) => onAssetEdit(postIndex, 0, src)}
                />
            }
            
            {/* Add Asset Button */}
            {isEditable && !isSimpleView && assets?.length == 0 &&
                <div className="px-4 py-2">
                    <AddAssetButton 
                        network={network}
                        onAssetNew={(asset) => onAssetNew(postIndex, asset)}
                        onAssetDelete={(assetIndex) => onAssetDelete(postIndex, assetIndex)}
                        post={post}
                    />
                </div>
            }

            {/* Video Info Section */}
            <div className="p-4">
                {/* Title */}
                <h1 className="text-xl font-bold text-tertiary-700 dark:text-gray-100 mb-2">
                    <TextPreview 
                        text={title || "Video Title"} 
                        network={network} 
                        isEditable={isEditable && !isSimpleView}
                        isTitle={true}
                        post={post}
                        onTextEdit={(value) => onTitleEdit(postIndex, value)}
                        previewClassName="!text-xl !font-bold"
                        editClassName="w-full !text-xl !font-bold"
                        placeholder="Video Title"
                        magicEditorClassName="!bg-transparent"
                    />
                </h1>

                {/* Channel Info & Stats */}
                <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-3">
                        <img 
                            src={user_image || integration?.image?.url || company?.image?.url || `/img/socials-rounded/${network}.svg`}
                            className="rounded-full h-10 w-10" 
                            alt="Channel avatar"
                        />
                        <div className="flex flex-col">
                            <span className="font-bold text-tertiary-700 dark:text-gray-100">
                                {user_name || integration?.name || company?.name}
                            </span>
                            <span className="text-sm text-tertiary-600 dark:text-gray-400">
                                {formatNumber(like_count || 0)} likes
                            </span>
                        </div>
                    </div>
                    <button className="bg-red-600 text-white px-4 py-2 rounded-full font-medium">
                        Subscribe
                    </button>
                </div>

                {/* Description */}
                <div className="bg-tertiary-100 dark:bg-gray-800 rounded-xl p-3">
                    {/* TODO: delete this label when youtube integration is approved */}
                    <label className="text-sm text-tertiary-600 dark:text-gray-400 mb-2 inline-block">Video Description</label>
                    <TextPreview 
                        text={text} 
                        network={network} 
                        isEditable={isEditable && !isSimpleView}
                        post={post}
                        onTextEdit={(value) => onTextEdit(postIndex, value)}
                        magicEditorClassName="!bg-transparent"
                        optionsBarClassName="!bg-transparent"
                    />
                </div>

                
            </div>
        </div>
    );
};

export default YoutubeVideoPreview;
